// src/components/common/CopyableField.tsx
import { IconButton, Paper, Stack, Typography } from "@mui/material";
import React from "react";

export type CopyableFieldProps = {
  /** ค่าที่จะแสดงและใช้เป็นข้อความสำหรับคัดลอก */
  value: string;
  /** ถ้าอยากให้เปลี่ยน icon หรือ alt text เอง */
  copyIconSrc?: string;
  copyIconAlt?: string;
  /** ถ้าอยากทำอะไรเพิ่มหลังคัดลอกสำเร็จ (เช่น toast) */
  onCopied?: (value: string) => void;
  /** ถ้าอยากฝัง style เพิ่ม */
  sx?: React.ComponentProps<typeof Paper>["sx"];
};

export const CopyableField: React.FC<CopyableFieldProps> = ({
  value,
  copyIconSrc = "/img/copy.svg",
  copyIconAlt = "copy",
  onCopied,
  sx,
}) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      onCopied?.(value);
    } catch (error) {
      // จะ console อย่างเดียว หรือโยนให้ onCopied handle error เองก็ได้
      console.error("Failed to copy text: ", error);
    }
  };

  return (
    <Paper
      elevation={0}
      variant="outlined"
      sx={{
        height: "36px",
        boxSizing: "border-box",
        flexGrow: 1,
        p: 0,
        backgroundColor: "var(--gray5)",
        ...sx,
      }}
    >
      <Stack direction="row" height="100%">
        <Typography
          alignContent="center"
          sx={{ flexGrow: 1, px: "12px" }}
          noWrap
        >
          {value}
        </Typography>
        <IconButton
          color="primary"
          sx={{ p: "10px" }}
          aria-label="copy"
          onClick={handleCopy}
        >
          <img src={copyIconSrc} alt={copyIconAlt} />
        </IconButton>
      </Stack>
    </Paper>
  );
};

export default CopyableField;
